import React from "react";
// import picc from '../Assets/picc.jfif'

function Intro() {
  return (
    <>
      <center></center>

      <div className="myintro">
        <div className="txt">
          <h1 className="let">
            LET ME <span> INTRODUCE </span> MYSELF
          </h1>
          <br/>
          <br/>
          
          <p>
            A Programming insect living in his own virtual world 😉
            <br />
            <br /> I am fluent in classics like{" "}
            <i>C++, Java, Kotlin, Javascript and React.js</i> .<br />
            <br /> My field of Interest's are building{" "}
            <i>Mobile Applications</i> and also in areas related to{" "}
            <i>Web Applications</i> .<br />
            <br />
            I have developed multiple Mobile Apps with <i> Java,<br /> Kotlin & React Native Technologies </i>.
            <br />
            <br />
            I am looking forward to be an exceptional <i>Full Stack Developer</i> 
          </p>
        </div>
       

      </div>
    </>
  );
}

export default Intro;
